/* eslint-disable react/prop-types */
import React, { memo } from "react";
import { ImageItem } from "./imageItem";
import style from "./style.module.scss";

const ImageList = function ImageList({
  allImgIds,
  allImages,
  selectedId,
  handleScroll,
  handlePickImage,
  imageRefs,
  scrollContainerRef,
  setSelectedImageLoaded,
  selectedStatus
}) {
  const showStatus = !selectedStatus || selectedStatus?.length === 0;

  return (
    <div
      className={style.imagesArea}
      onScroll={handleScroll}
      ref={scrollContainerRef}
      style={{ scrollBehavior: "auto" }}
    >
      {allImgIds.length ? (
        allImgIds.map((id, index) => {
          const image = allImages[id];
          if (!image) return null;

          return (
            <div key={id} ref={(el) => (imageRefs.current[id] = el)}>
              <ImageItem
                image={image}
                index={index}
                isSelected={image.sourceId === selectedId}
                handlePickImage={handlePickImage}
                onLoadSelected={() => setSelectedImageLoaded(true)}
                showStatus={showStatus}
              />
            </div>
          );
        })
      ) : (
        <span>No images.</span>
      )}
    </div>
  );
};

export default memo(ImageList);
